module.exports = __webpack_public_path__ + "static/media/AppleAppStoreWhite.86444db7.png";